import { useCallback } from 'react';

import {
	createSingleQueryParamHook,
	useRouteActions,
} from '@confluence/route-manager/entry-points/RouteState';

const useAccountIdQueryParam = createSingleQueryParamHook('accountId');
const useUsernameQueryParam = createSingleQueryParamHook('username');
const useGrantAccessQueryParam = createSingleQueryParamHook('grantAccess');

export const useShouldShowGrantAccess = () => {
	const accountIdRaw = useAccountIdQueryParam();
	const username = useUsernameQueryParam();
	const grantAccess = useGrantAccessQueryParam();
	const shouldShowGrantAccess = Boolean((grantAccess && accountIdRaw) || username);

	const { setQueryParams } = useRouteActions();
	const clearGrantAccessQueryParams = useCallback(() => {
		setQueryParams(
			{
				grantAccess: undefined,
				accessType: undefined,
				accountId: undefined,
				username: undefined,
			},
			true,
		);
	}, [setQueryParams]);

	return { shouldShowGrantAccess, clearGrantAccessQueryParams };
};
